import services from '../services'
import * as types from './mutation-types'

export const getList = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_TRANSFERS, res.data)
  })
)

export const show = async ({ commit }, params) => {
  await services.find(params).then(res => {
    commit(types.SET_TRANSFER, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.save(obj).then(res => {
    commit(types.SET_TRANSFER, res.data.data)
    return res
  })
}

export const deleteTransfer = async ({ commit }, obj) => {
  await services.deleteTransfer(obj).then(res => {
    return res
  })
}
